import { gql } from '@apollo/client';

export const COMPLETE_AUDIT_SESSION = gql`
  mutation CompleteAuditSession($sessionId: ID!) {
    completeAuditSession(sessionId: $sessionId) {
      id
      name
      status
      completedAt
      updatedAt
      updatedBy
    }
  }
`;
